export enum CheckoutLifecycleEventPostMessageName {
    backToTicketSelection = 'backToTicketSelection',
    checkoutFormLoaded = 'checkoutFormLoaded',
    deliveryMethodFormLoaded = 'deliveryMethodFormLoaded',
    orderComplete = 'orderComplete',
    orderStart = 'orderStart',
    organizerQuestionsFormLoaded = 'organizerQuestionsFormLoaded',
    organizerQuestionsFormResize = 'organizerQuestionsFormResize',
    protectCheckout = 'protectCheckout',
    ticketQuantityChange = 'ticketQuantityChange',
    ticketSelectionCompactLoaded = 'ticketSelectionCompactLoaded',
    ticketSelectionLayoutStabilized = 'ticketSelectionLayoutStabilized',
    ticketSelectionResize = 'ticketSelectionResize',
    ticketSelectionSubmit = 'ticketSelectionSubmit',
    widgetModalClose = 'widgetModalClose',
    widgetRenderComplete = 'widgetRenderComplete',
}
